const wrapper = "_35swgepx84";
const rightContainer = "_35srcwevfb";
const progressText = "_35sp1kmpdrn";
const loader = "_35sl1pnznbb";

export { loader, progressText, rightContainer, wrapper };
import "./_audio-player.full.style.linaria.module.css";
//# sourceMappingURL=_audio-player.full.style.js.map
